import React, { useEffect, useState } from 'react'
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {adminHttp} from "~/Admin/services/http";
import Pagination from "react-js-pagination";
import AdminAddLanguage from "./AdminAddLanguage";
import ConfirmedLink from "~/Components/ConfirmedButton/ConfirmedLink";
import deleteIcon from "~/assets/icons/delete.png";
import {EditIcon} from "~/Components/Icons/Icons";
import AdminEditLanguage from "./AdminEditLanguage";
import placeholder from "~/assets/placeholder-image.svg";
import AdminImageUploader from "~/Admin/AdminImageUploader/AdminImageUploader";

const AdminLanguages = ({match, event, ...props}) => {

    const [response, setResponse] = useState({});

    const loadData = (page = 1) => {
        adminHttp
            .get('/languages?page=' + page)
            .then(res => setResponse(res.data));
    };

    useEffect(loadData, [event]);

    const handleDelete = (id) => {
        adminHttp
            .delete('/languages/' + id)
            .then(res => loadData());
    };

    return (
        <div className="languages">
            <div className="row">
                <div className="col-8">
                    <h2>Languages</h2>
                </div>
                <div className="col-4 text-right">
                    <AdminAddLanguage
                        onChange={loadData}
                        className="btn btn-primary btn-sm">Add Language</AdminAddLanguage>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-12">
                    <div className="card shadow-sm bg-white mt-3">
                        <div className="card-body">
                            <table className="table">

                                <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Code</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Rigth to left ?</th>
                                    <th scope="col">Active?</th>
                                    <th scope="col">Flag</th>

                                    <th scope="col"></th>
                                </tr>
                                </thead>

                                <tbody>
                                {response.data?.map((lang) => (
                                    <tr key={lang.id}>
                                        <td>{lang.id}</td>
                                        <td>{lang.code}</td>
                                        <td>{lang.name}</td>
                                        <td>{lang.rtl ? 'Yes' : 'No'}</td>
                                        <td>{lang.active ? 'Yes' : 'No'}</td>
                                        <td width={150}>

                                            <img className="img-thumbnail mb-2 d-block" src={lang.flag.download_url || placeholder} />

                                            <AdminImageUploader
                                                image={lang.flag}
                                                onChanged={loadData}
                                                className="text-primary cursor-pointer d-block small">Edit Flag</AdminImageUploader>
                                        </td>
                                        <td>

                                            {!lang.main && (
                                                <ConfirmedLink className="cursor-pointer float-right" onClick={() => handleDelete(lang.id)}>
                                                    <img src={deleteIcon}/>
                                                </ConfirmedLink>
                                            )}

                                            <AdminEditLanguage language={lang} onChange={loadData} className="cursor-pointer float-right mr-2">
                                                <EditIcon />
                                            </AdminEditLanguage>

                                        </td>
                                    </tr>
                                ))}
                                </tbody>

                            </table>
                            {response.per_page < response.total && (
                                <Pagination
                                    activePage={response.current_page}
                                    itemsCountPerPage={response.per_page}
                                    totalItemsCount={response.total}
                                    pageRangeDisplayed={5}
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    onChange={loadData}
                                />
                            )}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminLanguages);
